// extracted by mini-css-extract-plugin
module.exports = {"default":"Input_default__j6jtP","placeholder-hide":"Input_placeholder-hide__co56s"};